<template>

    <div>

        <inertia-head :title="title">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card shadow-sm">
                        <div class="card-body">

                            <h1 class="card-title h3">{{ title }}</h1>

                            <div v-html="content" class="overflow-auto bg-light border p-3 mb-3" style="max-height: 400px;">
                            </div>

                            <inertia-link :href="route('terms.post-customer-accept')"
                                          method="post"
                                          class="btn btn-lg btn-primary w-100"
                                          >
                                {{ __('AGB akzeptieren und weiter zum Marktplatz') }}
                            </inertia-link>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    export default {
        layout: SlimLayout,
        props: [
            'title',
            'content',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>